// extracted by mini-css-extract-plugin
export default {"calculate_box":"styles_calculate_box__HjUAu","input_range_box":"styles_input_range_box__VyevO","content":"styles_content__Esm1Z"};